import api from "./api";

const parkingYardService = {
  upload: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/parking-yards/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300000,
    });
  },

  search: (params = {}) => api.get("/parking-yards/search", { params }),

  list: (params = {}) => api.get("/parking-yards", { params }),

  getById: (id) => api.get(`/parking-yards/${id}`),

  setStatus: (id, isActive) => api.patch(`/parking-yards/${id}/status`, { isActive }),

  remove: (id) => api.delete(`/parking-yards/${id}`),

  downloadSample: () =>
    api.get("/parking-yards/sample", { responseType: "blob" }),
};

export default parkingYardService;
